export default function PHP_yield() {
  return (
    <div>
      <h1>PHP_yield</h1>
    </div>
  );
}
